import { ManageThreadsApi, useAPIQueryAndQueryKey } from "melco-shared-logic";
import { PublishState } from "../../helper/publishedState";

export const useManageThreadsGetDef = (
  threadId: string,
  publishState: PublishState
) => {
  let res = useAPIQueryAndQueryKey(
    ManageThreadsApi,
    ["useManageThreadsGetDef", threadId, publishState],
    async (api) => {
      //      let response = await api.threadsGetDef({
      //      id: threadId,
      //    publishState: publishState,
      //});
      let response = null;
      response = await api.threadsGetById({
        id: threadId,
        publishState: publishState
      })


      return response;
    }
  );

  console.log(res);
  return res;
};
